var map = {
	"./appointment.svg": "7667",
	"./article.svg": "f22a",
	"./category.svg": "5188",
	"./checklist.svg": "d854",
	"./excretion.svg": "cc0d",
	"./exercise.svg": "47fa",
	"./mindfulness.svg": "1fea",
	"./none.svg": "27ee7",
	"./questionnaire.svg": "5a29",
	"./survey.svg": "579d",
	"./symptom.svg": "0e37",
	"./unhide.svg": "ea90",
	"./vital.svg": "c482",
	"./yoga.svg": "2b24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adf2";